// Obra e Canção — tema DARK-FIRST (marrom profundo + âmbar/brasa).
// Cartões públicos são sempre renderizados sem a classe `.dark` (ver
// PublicCardRoute), então o par `light` precisa JÁ SER o visual escuro.
// Por isso light === dark nas cores estruturais.
const dark = {
  main:            '#191410',
  card:            '#241d16',
  surface:         '#322820',
  action:          '#e0a45c',
  actionHover:     '#ecb573',
  textPrimary:     '#f3ecdf',
  textSecondary:   '#d9ccb6',
  textMuted:       '#b3a184',
  textMutedSubtle: '#8a7a61',
  border:          '#4b3d2c',
  borderSubtle:    '#2c241c',
  link:            '#e0a45c',
  linkBg:          'rgba(224,164,92,0.14)',
  linkBorder:      '#6b4a22',
  linkHover:       'rgba(224,164,92,0.26)',
  inputBg:         '#1f1912',
  inputBorder:     '#4b3d2c',
  inputText:       '#f3ecdf',
  focusRing:       '#e0a45c',
  overlay:         'rgba(0,0,0,0.82)',
  confirm:         '#4b3d2c',
  confirmHover:    '#5c4a35',
  confirmText:     '#f3ecdf',
  confirmBg:       '#241d16',
  confirmBorder:   '#4b3d2c',
};

const same = (v) => ({ light: v, dark: v });

module.exports = {
  effect: 'music',
  fonts: { pair: 'serif-editorial' },
  colors: {
    main:            same(dark.main),
    card:            same(dark.card),
    surface:         same(dark.surface),
    action:          same(dark.action),
    actionHover:     same(dark.actionHover),
    textPrimary:     same(dark.textPrimary),
    textSecondary:   same(dark.textSecondary),
    textMuted:       same(dark.textMuted),
    textMutedSubtle: same(dark.textMutedSubtle),
    border:          same(dark.border),
    borderSubtle:    same(dark.borderSubtle),
    link:            same(dark.link),
    linkBg:          same(dark.linkBg),
    linkBorder:      same(dark.linkBorder),
    linkHover:       same(dark.linkHover),
    inputBg:         same(dark.inputBg),
    inputBorder:     same(dark.inputBorder),
    inputText:       same(dark.inputText),
    focusRing:       same(dark.focusRing),
    overlay:         same(dark.overlay),
    confirm:         same(dark.confirm),
    confirmHover:    same(dark.confirmHover),
    confirmText:     same(dark.confirmText),
    confirmBg:       same(dark.confirmBg),
    confirmBorder:   same(dark.confirmBorder),
    success:         { light: '#34d399', dark: '#34d399' },
    successHover:    { light: '#10b981', dark: '#10b981' },
    successBg:       { light: 'rgba(6,78,59,0.35)', dark: 'rgba(6,78,59,0.35)' },
    successText:     { light: '#6ee7b7', dark: '#6ee7b7' },
    successBorder:   { light: '#065f46', dark: '#065f46' },
    error:           { light: '#f87171', dark: '#f87171' },
    errorHover:      { light: '#ef4444', dark: '#ef4444' },
    errorBg:         { light: 'rgba(127,29,29,0.35)', dark: 'rgba(127,29,29,0.35)' },
    errorText:       { light: '#fca5a5', dark: '#fca5a5' },
    errorBorder:     { light: '#7f1d1d', dark: '#7f1d1d' },
    info:            { light: '#fb923c', dark: '#fb923c' },
    infoHover:       { light: '#f97316', dark: '#f97316' },
    infoBg:          { light: 'rgba(154,52,18,0.35)', dark: 'rgba(154,52,18,0.35)' },
    infoText:        { light: '#fdba74', dark: '#fdba74' },
    infoBorder:      { light: '#7c2d12', dark: '#7c2d12' },
  },
  borderRadius: {
    card:      '18px',
    container: '14px',
    page:      '20px',
    button:    '9999px',
    input:     '14px',
    badge:     '6px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '4px',
    device:  '6px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
